































































import CommonModule             from "@/store/modules/common";
import { NavRouteItem }         from "@/types";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
      components: {}
  })
  export default class DevNavBar extends Vue {
      @Prop()
      public menuItems!: NavRouteItem[];

      private thisYear: number = (new Date()).getFullYear();

      get fullscreenSynced(): boolean {
          return CommonModule.fullscreen;
      }

      set fullscreenSynced(value: boolean) {
          CommonModule.setFullscreen(value);
      }

      get showSynced(): boolean {
          return CommonModule.loading;
      }

      set showSynced(value: boolean) {
          CommonModule.setLoading(value);
      }
  }
